export const licenses = {
  'MIT': {
    count: 1047,
    packages: [
      '@adobe/css-tools@4.4.4', '@alloc/quick-lru@5.2.0', '@apideck/better-ajv-errors@0.3.6',
      '@babel/code-frame@7.27.1', '@babel/compat-data@7.28.5', '@babel/core@7.28.5',
      '@babel/eslint-parser@7.28.5', '@babel/generator@7.28.5', '@babel/helper-annotate-as-pure@7.27.3',
      '@babel/helper-compilation-targets@7.27.2', '@babel/helper-create-class-features-plugin@7.28.5',
      '@babel/helper-create-regexp-features-plugin@7.28.5', '@babel/helper-define-polyfill-provider@0.6.5',
      '@babel/helper-globals@7.28.0', '@babel/helper-member-expression-to-functions@7.28.5',
      '@babel/helper-module-imports@7.27.1', '@babel/helper-module-transforms@7.28.3',
      '@babel/helper-optimise-call-expression@7.27.1', '@babel/helper-plugin-utils@7.27.1',
      '@babel/helper-remap-async-to-generator@7.27.1'
    ]
  },
  'ISC': {
    count: 62,
    packages: [
      '@isaacs/cliui@8.0.2', '@istanbuljs/load-nyc-config@1.1.0', '@trysound/sax@0.2.0',
      '@ungap/structured-clone@1.3.0', 'anymatch@3.1.3', 'at-least-node@1.0.0',
      'boolbase@1.0.0', 'cliui@7.0.4', 'css-declaration-sorter@6.4.1',
      'electron-to-chromium@1.5.244', 'fastq@1.19.1', 'flatted@3.3.3',
      'foreground-child@3.3.1', 'fs.realpath@1.0.0', 'get-caller-file@2.0.5',
      'get-own-enumerable-property-symbols@3.0.2', 'glob-parent@5.1.2', 'glob-parent@6.0.2',
      'glob@10.4.5', 'glob@7.2.3'
    ]
  },
  'Apache-2.0': {
    count: 30,
    packages: [
      '@humanwhocodes/config-array@0.13.0', '@humanwhocodes/module-importer@1.0.1',
      '@surma/rollup-plugin-off-main-thread@2.2.3', '@webassemblyjs/leb128@1.13.2',
      '@xtuc/long@4.2.2', 'ansi-html-community@0.0.8', 'ansi-html@0.0.9',
      'aria-query@5.3.0', 'aria-query@5.3.2', 'axobject-query@4.1.0',
      'baseline-browser-mapping@2.8.23', 'bser@2.1.1', 'didyoumean@1.2.2',
      'doctrine@2.1.0', 'doctrine@3.0.0', 'ejs@3.1.10',
      'eslint-visitor-keys@2.1.0', 'eslint-visitor-keys@3.4.3', 'faye-websocket@0.11.4',
      'fb-watchman@2.0.2'
    ]
  },
  'BSD-2-Clause': {
    count: 37,
    packages: [
      '@typescript-eslint/parser@5.62.0', '@typescript-eslint/typescript-estree@5.62.0',
      'browser-process-hrtime@1.0.0', 'css-select@2.1.0', 'css-select@4.3.0',
      'css-what@3.4.2', 'css-what@6.2.2', 'damerau-levenshtein@1.0.8',
      'default-gateway@6.0.3', 'domelementtype@1.3.1', 'domelementtype@2.3.0',
      'domhandler@4.3.1', 'domutils@1.7.0', 'domutils@2.8.0',
      'dotenv-expand@5.1.0', 'dotenv@10.0.0', 'entities@2.2.0',
      'escodegen@1.14.3', 'escodegen@2.1.0', 'eslint-scope@5.1.1'
    ]
  },
  'BSD-3-Clause': {
    count: 26,
    packages: [
      '@humanwhocodes/object-schema@2.0.3', '@sinonjs/commons@1.8.6', '@sinonjs/fake-timers@8.1.0',
      '@xtuc/ieee754@1.2.0', 'abab@2.0.6', 'babel-plugin-istanbul@6.1.1',
      'eslint-plugin-flowtype@8.0.3', 'esquery@1.6.0', 'fast-uri@3.1.0',
      'filesize@8.0.7', 'istanbul-lib-coverage@3.2.2', 'istanbul-lib-instrument@5.2.1',
      'istanbul-lib-report@3.0.1', 'istanbul-lib-source-maps@4.0.1', 'istanbul-reports@3.2.0',
      'makeerror@1.0.12', 'qs@6.13.0', 'serialize-javascript@4.0.0',
      'serialize-javascript@6.0.2', 'source-map-js@1.2.1'
    ]
  },
  'CC0-1.0': {
    count: 42,
    packages: [
      '@csstools/normalize.css@12.1.1', '@csstools/postcss-cascade-layers@1.1.1',
      '@csstools/postcss-color-function@1.1.1', '@csstools/postcss-font-format-keywords@1.0.1',
      '@csstools/postcss-hwb-function@1.0.2', '@csstools/postcss-ic-unit@1.0.1',
      '@csstools/postcss-is-pseudo-class@2.0.7', '@csstools/postcss-nested-calc@1.0.0',
      '@csstools/postcss-normalize-display-values@1.0.1', '@csstools/postcss-oklab-function@1.1.1',
      '@csstools/postcss-progressive-custom-properties@1.3.0', '@csstools/postcss-stepped-value-functions@1.0.1',
      '@csstools/postcss-text-decoration-shorthand@1.0.0', '@csstools/postcss-trigonometric-functions@1.0.2',
      '@csstools/postcss-unset-value@1.0.2', '@csstools/selector-specificity@2.2.0',
      'css-blank-pseudo@3.0.3', 'css-has-pseudo@3.0.4', 'css-prefers-color-scheme@6.0.3',
      'cssdb@7.11.2'
    ]
  }
};
